module.exports = __webpack_public_path__ + "static/media/Volume.adc2b338.svg";